import axios from "axios"
import { call, put, select, delay } from "redux-saga/effects"
import { toast } from "react-toastify"
import slice from "../slice/user"
import calendarSlice from "../../L&D/slice/user"
import { appActions } from "redux/app/slice/app"
import { formatDate } from "helpers/functions"
import { GMActions } from "redux/GM/slice/user"
import DMV_Slice from "../../DMV/slice/user"
import { saveAs } from "file-saver"
import moment from "moment"

const baseUrl = process.env.REACT_APP_API_MY_URL

export function* raffleTicket(action) {
  try {
    yield call(axios.post, `${baseUrl}/frontline/raffle/`, action.payload)
    const { data } = yield call(axios.get, `${baseUrl}/frontline/raffle/`)
    if (data.success) {
      yield put(slice.actions.setRaffleListData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadWineOfTheMonthThumbnail(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setWineMonthVideoThumbnail(data.data.id))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}
export function* uploadPDFThumbnail(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setWineMonthPDFThumbnail(data.data.id))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadWineOfTheMonth(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const date = yield select((store) => store.app?.filters?.date)
    const { data } = yield call(axios.post, `${baseUrl}/frontline/featured-item/`, action.payload)
    if (data.success) {
      const dateObject = new Date(date)
      const newDate = new Date(dateObject.getFullYear(), dateObject.getMonth() + 1, 0)
      const alcohol_type = yield select((store) => store.app?.filters?.alcohol_type)
      let params = ""
      if (alcohol_type && alcohol_type !== "All") {
        params = `&alcohol_type=${alcohol_type}`
      }
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/featured-item/?month=${formatDate(newDate)}${params}`
      )
      if (data.success) {
        yield put(slice.actions.setWineMonthListData(data.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
  yield put(slice.actions.setWineMonthPDFThumbnail(""))
  yield put(slice.actions.setWineMonthVideoThumbnail(""))
}

export function* getListWineMonth(action) {
  try {
    const { date, alcohol_type } = action.payload
    let params = date ? `month=${date}` : `month=${moment(new Date()).format("YYYY-MM-DD")}`
    if (alcohol_type && alcohol_type !== "All") {
      params += `&alcohol_type=${alcohol_type}`
    }
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/featured-item/?${params}`)
    if (data.success) {
      yield put(slice.actions.setWineMonthListData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteWineOfTheMonthItem(action) {
  yield put(appActions.setIsLoading(true))
  const date = yield select((store) => store.app?.filters?.date)
  try {
    yield call(axios.delete, `${baseUrl}/frontline/featured-item/${action.payload}`)
    const dateObject = new Date(date)
    const newDate = new Date(dateObject.getFullYear(), dateObject.getMonth() + 1, 0)
    const alcohol_type = yield select((store) => store.app?.filters?.alcohol_type)
    let params = ""
    if (alcohol_type && alcohol_type !== "All") {
      params = `&alcohol_type=${alcohol_type}`
    }
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/featured-item/?month=${formatDate(newDate)}${params}`
    )
    if (data.success) {
      toast.success("Featured item deleted successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(slice.actions.setWineMonthListData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getSingleWineMonthData() {
  try {
    const id = yield select((store) => store?.marketing?.featureItemMonth?.featureItemId ?? "")
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/featured-item/${id}`)
    if (data.success) {
      yield put(slice.actions.setGetSingleWineMonthData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editWineOfTheMonthItem(action) {
  const date = yield select((store) => store.app?.filters?.date)
  const alcohol_type = yield select((store) => store.app?.filters?.alcohol_type)
  let params = ""
  if (alcohol_type && alcohol_type !== "All") {
    params = `&alcohol_type=${alcohol_type}`
  }
  try {
    yield put(appActions.setIsLoading(true))
    const id = yield select((store) => store.marketing?.featureItemMonth?.featureItemId)
    yield call(axios.patch, `${baseUrl}/frontline/featured-item/${id}`, action.payload)
    const dateObject = new Date(date)
    const newDate = new Date(dateObject.getFullYear(), dateObject.getMonth() + 1, 0)
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/featured-item/?month=${formatDate(newDate)}${params}`
    )
    if (data.success) {
      const { data: singleData } = yield call(axios.get, `${baseUrl}/frontline/featured-item/${id}`)
      yield put(slice.actions.setGetSingleWineMonthData(singleData.data))
      yield put(slice.actions.setWineMonthListData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
  yield put(slice.actions.setWineMonthPDFThumbnail(""))
  yield put(slice.actions.setWineMonthVideoThumbnail(""))
}

export function* editRaffleContest(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const raffleID = yield select((store) => store?.marketing?.raffleContestData.id)

    yield call(axios.patch, `${baseUrl}/frontline/raffle/${raffleID}/`, action.payload)

    const { data } = yield call(axios.get, `${baseUrl}/frontline/raffle/`)
    if (data.success) {
      yield put(slice.actions.setRaffleListData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRaffleListData() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/raffle/`)
    if (data.success) {
      yield put(slice.actions.setRaffleListData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteRaffleContest() {
  const raffleId = yield select((store) => store.marketing?.raffleContestData?.id)
  try {
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/frontline/raffle/${raffleId}/`)
    const { data } = yield call(axios.get, `${baseUrl}/frontline/raffle/`)
    if (data.success) {
      yield put(slice.actions.setRaffleListData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRaffleSingleData() {
  try {
    yield put(appActions.setIsLoading(true))
    const raffleId = yield select((store) => store.marketing?.raffleContestData?.id)
    const { data } = yield call(axios.get, `${baseUrl}/frontline/raffle/${raffleId}/`)
    if (data.success) {
      yield put(slice.actions.setRaffleSingleData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addCommentCalender(action) {
  const { filters } = yield select((store) => store?.app || {})
  const dateObject = new Date(filters?.date)
  const newDate = new Date(dateObject.getFullYear(), dateObject.getMonth() + 1, 0)
  let params = `date=${formatDate(newDate)}`
  if (filters?.restaurant && filters?.restaurant !== "All") {
    params += `&restaurant=${filters?.restaurant}`
  }
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/trivia-note/`, action.payload)
    if (data.success) {
      yield put(appActions.setIsLoading(false))
      const { data: calendarData } = yield call(
        axios.get,
        `${baseUrl}/trivia/calendar-api/?${params}`
      )
      if (calendarData.success) {
        yield put(calendarSlice.actions.setCalendarData(calendarData.data || []))
        yield put(GMActions.setGMCalendarData(calendarData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* EditCommentCalender(action) {
  const { filters } = yield select((store) => store?.app || {})
  const dateObject = new Date(filters?.date)
  const newDate = new Date(dateObject.getFullYear(), dateObject.getMonth() + 1, 0)
  let params = `date=${formatDate(newDate)}`
  if (filters?.restaurant && filters?.restaurant !== "All") {
    params += `&restaurant=${filters?.restaurant}`
  }
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/trivia/trivia-note/${action.payload.id}/`,
      {
        note: action.payload.note
      }
    )
    if (data.success) {
      const { data: calendarData } = yield call(
        axios.get,
        `${baseUrl}/trivia/calendar-api/?${params}`
      )
      if (calendarData.success) {
        yield put(calendarSlice.actions.setCalendarData(calendarData.data || []))
        yield put(GMActions.setGMCalendarData(calendarData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getMenuPeriod(action) {
  // eslint-disable-next-line no-unsafe-optional-chaining
  const archived = action?.payload
  const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    let params = ""
    if (item) {
      params = item.replace(/&/g, "%26")
    }
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/web-menu-list/?meal-period=${params}&food-type=${category}${
        archived ? `&item_state=archived` : ""
      }`
    )
    if (data.success) {
      yield put(slice.actions.setMenuPeriodData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editMenuCategory(action) {
  const { food_category, mealCategoryId, meal_period, name } = action.payload
  const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    let params = ""
    if (item) {
      params = item.replace(/&/g, "%26")
    }
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/sub-category/${mealCategoryId}`,
      {
        meal_period: meal_period,
        food_category: food_category,
        name: name
      }
    )
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?meal-period=${params}&food-type=${category}`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuPeriodData(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addMenuCategory(action) {
  const { food_category, meal_period, name } = action.payload
  const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/sub-category/`, {
      meal_period: meal_period,
      food_category: food_category,
      name: name
    })
    let params = ""
    if (item) {
      params = item.replace(/&/g, "%26")
    }
    if (data.success) {
      yield put(slice.actions.setMenuCategoryId(data.data.id))
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?meal-period=${params}&food-type=${category}`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuPeriodData(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addMenuItems(action) {
  const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    const { payload, onClose } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/food-item/`, payload)
    if (data.success) {
      onClose()
      yield put(slice.actions.setMenuCategoryId(data.data.id))
      let params = ""
      if (item) {
        params = item.replace(/&/g, "%26")
      }
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?meal-period=${params}&food-type=${category}`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuPeriodData(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteMenuCategory(action) {
  const { mealCategoryId } = action.payload
  const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/frontline/sub-category/${mealCategoryId}`)

    let params = ""
    if (item) {
      params = item.replace(/&/g, "%26")
    }
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/frontline/web-menu-list/?meal-period=${params}&food-type=${category}`
    )
    if (newData.success) {
      yield put(slice.actions.setMenuPeriodData(newData.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteMenuItem(action) {
  const { pending_review } = action.payload || {}
  const Id = yield select((store) => store?.marketing?.menu?.menu_item_ID || {})
  const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  const { isArchive } = yield select((store) => store?.marketing?.menu || {})
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/frontline/food-item/${Id}${pending_review ? "?pending_review=true" : ""}`
    )
    console.log(data)

    let params = ""
    if (item) {
      params = item.replace(/&/g, "%26")
    }
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/frontline/web-menu-list/?meal-period=${params}&food-type=${category}${
        isArchive === true ? `&item_state=archived` : pending_review ? `&pending_review=true` : ""
      }`
    )
    if (newData.success) {
      if (pending_review) {
        yield put(slice.actions.setReviewMenuPeriodData(newData.data))
      } else {
        yield put(slice.actions.setMenuPeriodData(newData.data))
      }
      yield put(slice.actions.setisArchive(false))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getFoodItems() {
  const { menu_item_ID } = yield select((store) => store?.marketing?.menu || {})
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}`)
    if (data.success) {
      yield put(slice.actions.setFoodItemsDetail(data.data))
      yield put(appActions.setIsLoading(false))
    }
  } catch (e) {
    console.log(e)
    yield put(appActions.setIsLoading(false))
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateFoodItems(action) {
  const { menu_item_ID } = yield select((store) => store?.marketing?.menu || {})
  const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  const { isArchive } = yield select((store) => store?.marketing?.menu || {})
  try {
    const { payload, onClose, pending_review, keepDetail } = action.payload
    let params = ""
    if (item) {
      params = item.replace(/&/g, "%26")
    }
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}`,
      payload
    )
    if (data.success) {
      onClose()
      if (!keepDetail) {
        yield put(slice.actions.setFoodItemsDetail(data.data))
      }
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?meal-period=${params}&food-type=${category}${
          isArchive === true ? `&item_state=archived` : pending_review ? `&pending_review=true` : ""
        }`
      )
      if (newData.success) {
        if (pending_review) {
          yield put(slice.actions.setReviewMenuPeriodData(newData.data))
        } else {
          yield put(slice.actions.setMenuPeriodData(newData.data))
        }
      }
      yield put(slice.actions.setisArchive(false))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* moveFoodItemCategory(action) {
  // Persists a drag-and-drop move (within a category or across categories).
  // The UI updates optimistically; after the API responds we re-fetch the list
  // (see finally) so it reflects the server's authoritative order, and that same
  // re-fetch reverts the optimistic update if the request failed.
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    const { payload } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/food-item/move-category/`,
      payload
    )
    if (!data?.success) {
      throw new Error("Failed to move item")
    }
  } catch (e) {
    console.log(e)
  } finally {
    // Re-fetch the list so the UI reflects the server's authoritative order after
    // a successful drag; on failure the same re-fetch reverts the optimistic update.
    if (item === "bar menu") {
      yield call(getBarMenu)
    } else if (item === "wine by glass" || item === "wine by bottle") {
      yield call(getWineMenu)
    } else {
      yield call(getMenuPeriod)
    }
  }
}

export function* reorderMenuItems(action) {
  // Persists a within-category reorder (drag-and-drop). Like moveFoodItemCategory,
  // the UI updates optimistically and we re-fetch the list afterwards (see finally)
  // to reflect the server's authoritative order, which also reverts on failure.
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    const { payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/frontline/food-item/item-order/`, payload)
    if (!data?.success) {
      throw new Error("Failed to reorder items")
    }
  } catch (e) {
    console.log(e)
  } finally {
    // Re-fetch the list so the UI reflects the server's authoritative order after
    // a successful drag; on failure the same re-fetch reverts the optimistic update.
    if (item === "bar menu") {
      yield call(getBarMenu)
    } else if (item === "wine by glass" || item === "wine by bottle") {
      yield call(getWineMenu)
    } else {
      yield call(getMenuPeriod)
    }
  }
}

export function* reorderMenuCategories(action) {
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  const menuSubCategory = yield select((store) => store?.marketing?.menu?.menuSubCategory || [])
  try {
    const { payload } = action.payload
    let apiPayload = { ...payload }
    // Food menus need meal_period_id; bar/wine do not.
    if (item !== "bar menu" && item !== "wine by glass" && item !== "wine by bottle") {
      const mealPeriodEntry = menuSubCategory.find(
        (s) => s.name?.toLowerCase() === item?.toLowerCase()
      )
      if (mealPeriodEntry?.id) {
        apiPayload.meal_period_id = mealPeriodEntry.id
      }
    }
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/food-item/category-order/`,
      apiPayload
    )
    if (!data?.success) {
      throw new Error("Failed to reorder categories")
    }
  } catch (e) {
    console.log(e)
  } finally {
    if (item === "bar menu") {
      yield call(getBarMenu)
    } else if (item === "wine by glass" || item === "wine by bottle") {
      yield call(getWineMenu)
    } else {
      yield call(getMenuPeriod)
    }
  }
}

export function* uploadMenuItem(action) {
  // Back-compat: callers may dispatch the FormData directly, or wrap it as
  // { data, onSuccess } to receive the uploaded media ({ id, url }) back.
  const payload = action.payload
  const isWrapped = payload && !(payload instanceof FormData) && payload.data
  const body = isWrapped ? payload.data : payload
  const onSuccess = isWrapped ? payload.onSuccess : null
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, body)
    if (data.success) {
      yield put(slice.actions.setMenuImageId(data.data.id))
      if (typeof onSuccess === "function") {
        onSuccess(data.data)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadTastingNotesImages(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload.data)
    if (data.success) {
      yield put(
        slice.actions.setTastingNotesImages({
          index: action.payload.indexValue,
          id: data.data.id
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getLeaderboardData(action) {
  const { date, page, employeeClass, orderBy } = action.payload
  let params = `?month=${date}&page=${page}`
  if (employeeClass && employeeClass !== "All") {
    params += `&job_class=${employeeClass}`
  }
  if (orderBy) {
    params += `&ordering=${orderBy}`
  }
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/trivia/advance-leaderboard/${params}`)
    if (data.success) {
      yield put(slice.actions.setLoaderBoardData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNewLeaderboardData(action) {
  const { date, page, employeeClass, orderBy, weeks } = action.payload
  let params = `?month=${date}&page=${page}`
  if (employeeClass && employeeClass !== "All") {
    params += `&job_class=${employeeClass}`
  }
  if (weeks && weeks.label !== "All") {
    params += `&start_date=${weeks.value.start}&end_date=${weeks.value.end}`
  }
  if (orderBy) {
    params += `&ordering=${orderBy}`
  }
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/weekly/advance-leaderboard/${params}`)
    if (data.success) {
      yield put(slice.actions.setLoaderBoardData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getSingleUserDataGraph(action) {
  const { userId } = yield select((store) => store?.marketing?.leaderboard || "")
  const { date } = action.payload
  let params = `&month=${date}`
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/trivia/trivia-score-graph/?user_id=${userId}${params}`
    )
    if (data.success) {
      yield put(slice.actions.setSingleUserDataGraph(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getBarMenu(action) {
  // eslint-disable-next-line no-unsafe-optional-chaining
  const archived = action?.payload
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/bar-menu-web${archived ? `?&item_state=archived` : ""}`
    )
    if (data.success) {
      yield put(slice.actions.setBarMenuPeriodData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getWineMenu(action) {
  // eslint-disable-next-line no-unsafe-optional-chaining
  const archived = action?.payload
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    if (item === "wine by glass") {
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True${
          archived ? `&item_state=archived` : ""
        }`
      )
      if (data.success) {
        yield put(slice.actions.setWineMenuPeriodData(data.data))
      }
    } else {
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True${
          archived ? `&item_state=archived` : ""
        }`
      )
      if (data.success) {
        yield put(slice.actions.setWineMenuPeriodData(data.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addWineMenuItems(action) {
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    const { payload, onClose } = action.payload
    yield put(appActions.setIsLoading(true))
    if (item === "wine by glass") {
      const { data } = yield call(
        axios.post,
        `${baseUrl}/frontline/food-item/?wine-by-glass=True`,
        payload
      )
      if (data.success) {
        onClose()
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True`
        )
        if (newData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      }
    } else {
      const { data } = yield call(
        axios.post,
        `${baseUrl}/frontline/food-item/?wine-by-bottle=True`,
        payload
      )
      if (data.success) {
        onClose()
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True`
        )
        if (newData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editWineMenuItem(action) {
  const { menu_item_ID } = yield select((store) => store?.marketing?.menu || {})
  const { isArchive } = yield select((store) => store?.marketing?.menu || {})
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    const { payload, onClose, pending_review, keepDetail } = action.payload
    yield put(appActions.setIsLoading(true))
    if (item === "wine by glass") {
      const { data } = yield call(
        axios.patch,
        `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?wine-by-glass=True`,
        payload
      )
      if (data.success) {
        if (!keepDetail) {
          yield put(slice.actions.setFoodItemsDetail({}))
        }
        onClose()
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True${
            isArchive === true
              ? `&item_state=archived`
              : pending_review
              ? `&pending_review=true`
              : ""
          }`
        )
        if (newData.success) {
          if (pending_review) {
            yield put(slice.actions.setReviewWineMenuPeriodData(newData.data))
          } else {
            yield put(slice.actions.setWineMenuPeriodData(newData.data))
          }
        }
      }
      yield put(slice.actions.setisArchive(false))
    } else {
      const { data } = yield call(
        axios.patch,
        `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?wine-by-bottle=True`,
        payload
      )
      if (data.success) {
        if (!keepDetail) {
          yield put(slice.actions.setFoodItemsDetail({}))
        }
        onClose()
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True${
            isArchive === true
              ? `&item_state=archived`
              : pending_review
              ? `&pending_review=true`
              : ""
          }`
        )
        if (newData.success) {
          if (pending_review) {
            yield put(slice.actions.setReviewWineMenuPeriodData(newData.data))
          } else {
            yield put(slice.actions.setWineMenuPeriodData(newData.data))
          }
        }
      }
      yield put(slice.actions.setisArchive(false))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getWineItems() {
  const { menu_item_ID } = yield select((store) => store?.marketing?.menu || {})
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    if (item === "wine by glass") {
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?wine-by-glass=True`
      )
      if (data.success) {
        yield put(slice.actions.setFoodItemsDetail(data.data))
      }
    } else {
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?wine-by-bottle=True`
      )
      if (data.success) {
        yield put(slice.actions.setFoodItemsDetail(data.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteWineMenuItem(action) {
  const { pending_review } = action.payload || {}
  const { menu_item_ID } = yield select((store) => store?.marketing?.menu || {})
  const { isArchive } = yield select((store) => store?.marketing?.menu || {})
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    if (item === "wine by glass") {
      yield call(
        axios.delete,
        `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?wine-by-glass=True${
          pending_review ? "&pending_review=true" : ""
        }`
      )
      yield put(slice.actions.setFoodItemsDetail({}))
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True${
          isArchive === true ? `&item_state=archived` : pending_review ? `&pending_review=true` : ""
        }`
      )
      if (newData.success) {
        if (pending_review) {
          yield put(slice.actions.setReviewWineMenuPeriodData(newData.data))
        } else {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      }
    } else {
      yield call(
        axios.delete,
        `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?wine-by-bottle=True${
          pending_review ? "&pending_review=true" : ""
        }`
      )
      yield put(slice.actions.setFoodItemsDetail({}))
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True${
          isArchive === true ? `&item_state=archived` : pending_review ? `&pending_review=true` : ""
        }`
      )
      if (newData.success) {
        if (pending_review) {
          yield put(slice.actions.setReviewWineMenuPeriodData(newData.data))
        } else {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addBarMenuItems(action) {
  try {
    const { payload, onClose } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/food-item/?bar-menu=True`,
      payload
    )
    if (data.success) {
      onClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/bar-menu-web`)
      if (newData.success) {
        yield put(slice.actions.setBarMenuPeriodData(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editBarMenuItem(action) {
  const { menu_item_ID } = yield select((store) => store?.marketing?.menu || {})
  const { isArchive } = yield select((store) => store?.marketing?.menu || {})
  try {
    const { payload, onClose, pending_review, keepDetail } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?bar-menu=True`,
      payload
    )
    if (data.success) {
      onClose()
      if (!keepDetail) {
        yield put(slice.actions.setFoodItemsDetail({}))
      }
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/bar-menu-web${
          isArchive === true ? `?item_state=archived` : pending_review ? `?pending_review=true` : ""
        }`
      )
      if (newData.success) {
        if (pending_review) {
          yield put(slice.actions.setReviewBarMenuPeriodData(newData.data))
        } else {
          yield put(slice.actions.setBarMenuPeriodData(newData.data))
        }
      }
      yield put(slice.actions.setisArchive(false))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getBarItems() {
  const { menu_item_ID } = yield select((store) => store?.marketing?.menu || {})
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?bar-menu=True`
    )
    if (data.success) {
      yield put(slice.actions.setFoodItemsDetail(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteBarMenuItem(action) {
  const { pending_review } = action.payload || {}
  const { menu_item_ID } = yield select((store) => store?.marketing?.menu || {})
  const { isArchive } = yield select((store) => store?.marketing?.menu || {})
  try {
    yield put(appActions.setIsLoading(true))
    yield call(
      axios.delete,
      `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?bar-menu=True${
        pending_review ? "&pending_review=true" : ""
      }`
    )
    yield put(slice.actions.setFoodItemsDetail({}))
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/frontline/bar-menu-web${
        isArchive === true ? `?item_state=archived` : pending_review ? `?pending_review=true` : ""
      }`
    )
    if (newData.success) {
      if (pending_review) {
        yield put(slice.actions.setReviewBarMenuPeriodData(newData.data))
      } else {
        yield put(slice.actions.setBarMenuPeriodData(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* AddBarMenuCategory(action) {
  const { food_category, meal_period, name } = action.payload
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/bar-category/`, {
      meal_period: meal_period,
      food_category: food_category,
      name: name
    })
    if (data.success) {
      yield put(slice.actions.setMenuCategoryId(data.data.id))
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/bar-menu-web`)
      if (newData.success) {
        yield put(slice.actions.setBarMenuPeriodData(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editBarMenuCategory(action) {
  const { food_category, mealCategoryId, meal_period, name } = action.payload
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/bar-category/${mealCategoryId}`,
      {
        meal_period: meal_period,
        food_category: food_category,
        name: name
      }
    )
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/bar-menu-web`)
      if (newData.success) {
        yield put(slice.actions.setBarMenuPeriodData(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteBarMenuCategory(action) {
  const { mealCategoryId } = action.payload
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.delete, `${baseUrl}/frontline/bar-category/${mealCategoryId}`)
    console.log(data)

    const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/bar-menu-web`)
    if (newData.success) {
      yield put(slice.actions.setBarMenuPeriodData(newData.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* unArchiveItems(action) {
  try {
    const { payload, setSelectedItems } = action.payload
    const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/menu-archive/`, payload)
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?meal-period=${item}&food-type=${category}&item_state=archived
        `
      )
      if (data.success) {
        yield put(slice.actions.setMenuPeriodData(newData.data))
        setSelectedItems()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* unArchiveBarItems(action) {
  try {
    const { payload, setSelectedItems } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/menu-archive/`, payload)
    if (data.success) {
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/bar-menu-web?item_state=archived`
      )
      if (data.success) {
        setSelectedItems()
        yield put(slice.actions.setBarMenuPeriodData(data.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* importSpiritItem(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/spirit-import/`, action.payload)
    if (data.success) {
      const { menuCategory } = yield select((store) => store.dmv)
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?platform=marketing&item_state=available`
      )
      if (newData.success) {
        yield put(slice.actions.setSpiritData(newData?.data || []))
      }
      const { data: subCategoryData } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-sub-category/`
      )
      if (subCategoryData.success) {
        yield put(DMV_Slice.actions.setSpiritSubMenuItems(subCategoryData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getSpiritCMS(action) {
  try {
    const { menuCategory } = yield select((store) => store.dmv)
    if (menuCategory?.name) {
      yield put(appActions.setIsLoading(true))
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${
          menuCategory?.name
        }?platform=marketing&item_state=available${
          action.payload !== "" && action.payload ? `&search=${action.payload}` : ""
        }`
      )
      if (data.success) {
        yield put(slice.actions.setSpiritData(data?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getArchivedSpiritCMS() {
  try {
    const { menuCategory } = yield select((store) => store.dmv)
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?platform=marketing&item_state=archived`
    )
    if (data.success) {
      yield put(slice.actions.setSpiritData(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* unArchiveSpiritsItems(action) {
  try {
    const { payload, setSelectedItems } = action.payload
    const { menuCategory } = yield select((store) => store.dmv)
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/menu-archive/`, payload)
    if (data.success) {
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?platform=marketing&item_state=archived`
      )
      if (data.success) {
        setSelectedItems()
        yield put(slice.actions.setSpiritData(data.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* archiveSpiritItemsAction(action) {
  const { itemID, menuCategory } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/spirit-menu/${itemID ?? ""}`,
      action.payload
    )
    if (data.success) {
      const { data: newDta } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?platform=marketing&item_state=archived`
      )
      if (data.success) {
        yield put(slice.actions.setSpiritData(newDta.data))
      }
      const { data: subCategoryData } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-sub-category/`
      )
      if (subCategoryData.success) {
        yield put(DMV_Slice.actions.setSpiritSubMenuItems(subCategoryData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* unarchiveWineItem(action) {
  const { menu_item_ID } = yield select((store) => store?.marketing?.menu || {})
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    if (item === "wine by glass") {
      const { data } = yield call(
        axios.patch,
        `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?wine-by-glass=True`,
        action.payload
      )
      if (data.success) {
        yield put(slice.actions.setFoodItemsDetail({}))
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True&item_state=archived`
        )
        if (newData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      }
    } else {
      const { data } = yield call(
        axios.patch,
        `${baseUrl}/frontline/food-item/${menu_item_ID ?? ""}?wine-by-bottle=True`,
        action.payload
      )
      if (data.success) {
        yield put(slice.actions.setFoodItemsDetail({}))
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True&item_state=archived`
        )
        if (newData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addarchiveSpiritItems(action) {
  const { itemID, menuCategory } = yield select((store) => store.dmv)
  const { isArchive } = yield select((store) => store?.marketing?.menu || {})
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/spirit-menu/${itemID ?? ""}`,
      action.payload
    )
    if (data.success) {
      if (data.success) {
        const { data: newDta } = yield call(
          axios.get,
          `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?platform=marketing${
            isArchive === true ? `&item_state=archived` : `&item_state=available`
          }`
        )
        if (data.success) {
          yield put(slice.actions.setSpiritData(newDta.data))
        }
        yield put(slice.actions.setisArchive(false))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteSpiritMenuItem(action) {
  const { pending_review } = action.payload || {}
  const { itemID, menuCategory } = yield select((store) => store.dmv)
  const { isArchive } = yield select((store) => store?.marketing?.menu || {})
  try {
    yield put(appActions.setIsLoading(true))
    yield call(
      axios.delete,
      `${baseUrl}/frontline/spirit-menu/${itemID}${pending_review ? "?pending_review=true" : ""}`
    )
    yield put(slice.actions.setMenuCategoryId(""))
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?platform=marketing${
        isArchive === true
          ? `&item_state=archived`
          : pending_review
          ? `&pending_review=true`
          : "&item_state=available"
      }`
    )
    if (newData.success) {
      if (pending_review) {
        yield put(slice.actions.setReviewSpiritData(newData?.data || []))
      } else {
        yield put(slice.actions.setSpiritData(newData?.data || []))
      }
    }
    const { data: subCategoryData } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-sub-category/`
    )
    if (subCategoryData.success) {
      yield put(DMV_Slice.actions.setSpiritSubMenuItems(subCategoryData.data))
    }
    yield put(slice.actions.setisArchive(false))
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getSpiritItems() {
  const { itemID } = yield select((store) => store.dmv)
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/spirit-menu/${itemID ?? ""}?platform=marketing&item_state=available`
    )
    if (data.success) {
      yield put(DMV_Slice.actions.setSpiritMenuItem(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateSpiritItems(action) {
  const { itemID, menuCategory } = yield select((store) => store.dmv)
  const { isArchive } = yield select((store) => store?.marketing?.menu || {})
  try {
    yield put(appActions.setIsLoading(true))
    const { pending_review, ...dataPayload } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/spirit-menu/${itemID ?? ""}`,
      dataPayload
    )
    if (data.success) {
      yield put(slice.actions.setMenuCategoryId(data.data.id))
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?platform=marketing${
          isArchive === true
            ? `&item_state=archived`
            : pending_review
            ? `&pending_review=true`
            : `&item_state=available`
        }`
      )
      if (newData.success) {
        if (pending_review) {
          yield put(slice.actions.setReviewSpiritData(newData?.data || []))
        } else {
          yield put(slice.actions.setSpiritData(newData?.data || []))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNewSpiritCount() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/spirit-count/`)
    if (data.success) {
      yield put(slice.actions.setNewSpiritCount(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getGamificationLeaderboardData(action) {
  const { date, employeeClass, orderBy } = action.payload
  let params = `?month=${date}`
  if (employeeClass && employeeClass !== "All") {
    params += `&job_class=${employeeClass}`
  }
  if (orderBy) {
    params += `&ordering=${orderBy}`
  }
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/gamification-leaderboard/${params}`
    )
    if (data.success) {
      yield put(slice.actions.setGamificationLoaderBoardData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNewGamificationLeaderboardData(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { date, employeeClass, orderBy } = action.payload
    let params = `?month=${date}`
    if (employeeClass && employeeClass !== "All") {
      params += `&job_class=${employeeClass}`
    }
    if (orderBy) {
      params += `&ordering=${orderBy}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/weekly/gamification-leaderboard/${params}`)
    if (data.success) {
      yield put(slice.actions.setGamificationLoaderBoardData(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getQuizLeaderBoardData(action) {
  try {
    const { activeToggle, date, employeeClass, currentPage, weeks, orderBy } = action.payload
    yield put(appActions.setIsLoading(true))
    let params = `?filter_type=${activeToggle}&page=${currentPage}`
    if (date) {
      params += `&month=${date}`
    }
    if (employeeClass && employeeClass !== "All") {
      params += `&employee_class=${employeeClass}`
    }
    if (weeks && weeks.label !== "All") {
      params += `&start_date=${weeks.value.start}&end_date=${weeks.value.end}`
    }
    if (orderBy) {
      params += `&sort_by=${orderBy}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/frontline/quiz/leaderboard${params}`)
    if (data.success) {
      yield put(slice.actions.setQuizLeaderBoardData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getMenuSubCategory() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/food-type/`)
    if (data.success) {
      yield put(slice.actions.setMenuSubCategory(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadMenuBulk(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { csvUrl, menuCategory, onClose } = action.payload
    const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
    const headerParams = { headers: { "Content-Type": "multipart/form-data" } }
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/menu/bulk-upload?category=${menuCategory}`,
      { file: csvUrl },
      headerParams
    )
    if (data.success) {
      onClose()
      if (
        menuCategory == "Dinner" ||
        menuCategory == "Lunch" ||
        menuCategory == "Brunch" ||
        menuCategory == "Breakfast"
      ) {
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?meal-period=${item}&food-type=${category}`
        )
        if (newData.success) {
          yield put(slice.actions.setMenuPeriodData(newData.data))
        }
      } else if (menuCategory == "Bar Menu") {
        const { data: newBarData } = yield call(axios.get, `${baseUrl}/frontline/bar-menu-web`)
        if (newBarData.success) {
          yield put(slice.actions.setBarMenuPeriodData(newBarData.data))
        }
      } else if (menuCategory == "Wine By Glass") {
        const { data: newWineData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True`
        )
        if (newWineData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newWineData.data))
        }
      } else {
        const { data: newWineData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True`
        )
        if (newWineData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newWineData.data))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* AddWineMenuCategory(action) {
  const { food_category, meal_period, name } = action.payload
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    if (item === "wine by glass") {
      const { data } = yield call(axios.post, `${baseUrl}/frontline/wine-category/`, {
        meal_period: meal_period,
        food_category: food_category,
        name: name
      })
      if (data.success) {
        yield put(slice.actions.setMenuCategoryId(data.data.id))
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True`
        )
        if (newData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      }
    } else {
      const { data } = yield call(
        axios.post,
        `${baseUrl}/frontline/wine-category/?wine-by-bottle=True`,
        {
          meal_period: meal_period,
          food_category: food_category,
          name: name
        }
      )
      if (data.success) {
        yield put(slice.actions.setMenuCategoryId(data.data.id))
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True`
        )
        if (newData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editWineMenuCategory(action) {
  const { food_category, mealCategoryId, meal_period, name } = action.payload
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/wine-category/${mealCategoryId}`,
      {
        meal_period: meal_period,
        food_category: food_category,
        name: name
      }
    )
    if (data.success) {
      if (item === "wine by glass") {
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True`
        )
        if (newData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      } else {
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True`
        )
        if (newData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteWineMenuCategory(action) {
  const { mealCategoryId } = action.payload
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/frontline/wine-category/${mealCategoryId}`
    )
    if (data.success) {
      if (item === "wine by glass") {
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True`
        )
        if (newData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      } else {
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True`
        )
        if (newData.success) {
          yield put(slice.actions.setWineMenuPeriodData(newData.data))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* unArchiveWineItems(action) {
  try {
    const { payload, setSelectedItems } = action.payload
    const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/menu-archive/`, payload)
    if (data.success) {
      if (item === "wine by glass") {
        const { data } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True&item_state=archived`
        )
        if (data.success) {
          setSelectedItems()
          yield put(slice.actions.setWineMenuPeriodData(data.data))
        }
      } else {
        const { data } = yield call(
          axios.get,
          `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True&item_state=archived`
        )
        if (data.success) {
          setSelectedItems()
          yield put(slice.actions.setWineMenuPeriodData(data.data))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadDidYouKnowImage(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload.data)
    if (data.success) {
      yield put(
        slice.actions.setDidYouKnowImage({
          index: action.payload.index,
          id: data.data.id
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadHistoryMedia(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { type } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload.data)
    if (data.success) {
      yield put(
        slice.actions.setHistoryMedia({
          type,
          id: data.data.id
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* searchDidYouKnowImages(action) {
  // No global loader — the ImageSearchField shows its own local loading so the
  // rest of the form stays editable while images are being fetched.
  try {
    const { query, count, page } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/trivia/image-search/`, {
      query,
      count: count || 10,
      page: page || 1
    })
    if (data.success) {
      action.payload.onSuccess?.({
        results: data.data?.results || [],
        hasMore: !!data.data?.has_more,
        page: data.data?.page || page || 1
      })
    }
  } catch (e) {
    console.log(e)
    action.payload.onError?.(e)
  }
}

export function* confirmDidYouKnowImage(action) {
  // No global loader — the ImageSearchField shows its own local "Confirming..."
  // state so the rest of the form stays editable while the image is saved.
  try {
    const { url } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/trivia/image-search/confirm/`, { url })
    if (data.success) {
      action.payload.onSuccess?.(data.data)
    }
  } catch (e) {
    console.log(e)
    action.payload.onError?.(e)
  }
}

export function* getWeeklyChallenge(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { month, status, include_future } = action.payload
    let params = ""
    if (month) {
      params = `?month=${month}`
    }
    if (status) {
      params = `?status=${status}&include_future=${include_future}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/weekly/weekly-challenges/${params}`)
    if (data.success) {
      yield put(slice.actions.setWeeklyChallengeList(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNextWeeklyChallenge(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { month } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/weekly/weekly-challenges/?month=${month}`)
    if (data.success) {
      yield put(slice.actions.setNextWeeklyChallengeData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getLastWeeklyChallenge(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { month } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/weekly/weekly-challenges/?month=${month}`)
    if (data.success) {
      yield put(slice.actions.setLastWeeklyChallengeData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getPreviousToLastWeeklyChallenge(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { month } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/weekly/weekly-challenges/?month=${month}`)
    if (data.success) {
      yield put(slice.actions.setPreviousToLastWeeklyChallengeData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editWeeklyChallenge(action) {
  try {
    const { payload, handleRoute, isPublished } = action.payload
    const { weeklyChallengeId } = yield select((store) => store?.marketing)
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/weekly/weekly-challenges/${weeklyChallengeId}/`,
      payload
    )
    if (data.success) {
      yield put(slice.actions.setIsContestEdited(true))
      handleRoute()
      if (isPublished) {
        yield put(slice.actions.setStatusChanged(true))
      }
    }
  } catch (e) {
    console.log(e)
  }
}

export function* viewWeeklyChallenge() {
  try {
    const { weeklyChallengeId } = yield select((store) => store?.marketing)
    const { data } = yield call(
      axios.get,
      `${baseUrl}/weekly/weekly-challenges/${weeklyChallengeId}/`
    )
    if (data.success) {
      yield put(slice.actions.setWeeklyChallengeData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getWeeklyQuiz(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { month } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/weekly/weekly-quizzes/?month=${month}`)
    if (data.success) {
      yield put(slice.actions.setWeeklyQuizList(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNextWeeklyQuiz(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { month } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/weekly/weekly-quizzes/?month=${month}`)
    if (data.success) {
      yield put(slice.actions.setNextWeeklyQuizData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getLastWeeklyQuiz(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { month } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/weekly/weekly-quizzes/?month=${month}`)
    if (data.success) {
      yield put(slice.actions.setLastWeeklyQuizData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getPreviousToLastWeeklyQuiz(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { month } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/weekly/weekly-quizzes/?month=${month}`)
    if (data.success) {
      yield put(slice.actions.setPreviousToLastWeeklyQuizData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editWeeklyQuiz(action) {
  try {
    const { payload, handleRoute } = action.payload
    const { weeklyQuizId } = yield select((store) => store?.marketing)
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/weekly/weekly-quizzes/${weeklyQuizId}/`,
      payload
    )
    if (data.success) {
      yield put(slice.actions.setIsContestEdited(true))
      handleRoute()
    }
  } catch (e) {
    console.log(e)
  }
}

export function* viewWeeklyQuiz() {
  try {
    const { weeklyQuizId } = yield select((store) => store?.marketing)
    const { data } = yield call(axios.get, `${baseUrl}/weekly/weekly-quizzes/${weeklyQuizId}/`)
    if (data.success) {
      yield put(slice.actions.setWeeklyQuizData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getViewChallengeQuestions() {
  try {
    yield put(appActions.setIsLoading(true))
    const { weeklyChallengeId } = yield select((store) => store?.marketing)
    const { data } = yield call(
      axios.get,
      `${baseUrl}/weekly/weekly-challenges/${weeklyChallengeId}/questions-v2/`
    )
    if (data.success) {
      yield put(slice.actions.setViewChallengeQuestions(data.data?.questions ?? []))
      yield put(slice.actions.setChallengeQuestionsCount(data.data?.category_wise_count))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getViewQuizQuestions() {
  try {
    yield put(appActions.setIsLoading(true))
    const { weeklyQuizId } = yield select((store) => store?.marketing)
    const { data } = yield call(
      axios.get,
      `${baseUrl}/weekly/weekly-quizzes/${weeklyQuizId}/questions/`
    )
    if (data.success) {
      yield put(slice.actions.setViewQuizQuestions(data.data?.questions ?? []))
      yield put(slice.actions.setQuizQuestionsCount(data.data?.category_wise_count))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteChallengeQuestion(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { weeklyChallengeId } = yield select((store) => store?.marketing)
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/weekly/weekly-challenges/${weeklyChallengeId}/questions-v2/`,
      {
        data: { questions: [action.payload] }
      }
    )
    if (data.success) {
      const { data: questions } = yield call(
        axios.get,
        `${baseUrl}/weekly/weekly-challenges/${weeklyChallengeId}/questions-v2/`
      )
      if (questions.success) {
        yield put(slice.actions.setViewChallengeQuestions(questions.data?.questions ?? []))
        yield put(slice.actions.setChallengeQuestionsCount(questions.data?.category_wise_count))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editChallengeQuestion(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const {
      questionId,
      questionData,
      platform,
      question_used,
      weeklyChallenge,
      onClose,
      archived
    } = action.payload
    const { weeklyChallengeId } = yield select((store) => store?.marketing)
    let params = ""
    if (archived) {
      params += `&is_archived=${archived}`
    }
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/weekly/questions-v2/${questionId}/`,
      questionData
    )
    if (data.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        weeklyChallenge
          ? `${baseUrl}/weekly/weekly-challenges/${weeklyChallengeId}/questions-v2/`
          : `${baseUrl}/weekly/question-bank-v2/?page=1&platform=${platform}&question_used=${question_used}${params}`
      )
      if (newData.success) {
        if (weeklyChallenge) {
          yield put(slice.actions.setViewChallengeQuestions(newData.data?.questions ?? []))
          yield put(slice.actions.setChallengeQuestionsCount(newData.data?.category_wise_count))
        } else {
          yield put(slice.actions.setWeeklyQuestionBank(newData.data))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* weeklyCategory() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/menu/`)
    if (data.success) {
      yield put(slice.actions.setWeeklyCategoryList(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getWeeklyQuestionsBank(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { platform, question_used, archived } = action.payload
    let params = ""
    if (question_used) {
      if (question_used === "flagged") {
        params = `&is_flagged=true`
      } else {
        params = `&question_used=${question_used}`
      }
    }
    const { data } = yield call(
      axios.get,
      `${baseUrl}/weekly/question-bank-v2/?page=1&platform=${platform}&is_archived=${archived}${params}`
    )
    if (data.success) {
      yield put(slice.actions.setWeeklyQuestionBank(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* ReplaceChallengeMenuItem(action) {
  try {
    const { payload, onClose } = action.payload
    const { weeklyChallengeId } = yield select((store) => store?.marketing)
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/weekly/change-menu-item/`, payload)
    if (data.success) {
      onClose()
      const { data: questions } = yield call(
        axios.get,
        `${baseUrl}/weekly/weekly-challenges/${weeklyChallengeId}/questions-v2/`
      )
      if (questions.success) {
        yield put(slice.actions.setViewChallengeQuestions(questions.data?.questions ?? []))
        yield put(slice.actions.setChallengeQuestionsCount(questions.data?.category_wise_count))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addWeeklyManualQuestionToBank(action) {
  try {
    const { payload, handleRoute } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/weekly/questions/`, payload)
    if (data.success) {
      handleRoute()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/weekly/question-bank-v2/?page=1&page_size=9999`
      )
      if (newData.success) {
        yield put(slice.actions.setWeeklyQuestionBank(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addWeeklyManualQuestionV2ToBank(action) {
  try {
    const { payload, handleRoute } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/weekly/questions-v2/`, payload)
    if (data.success) {
      handleRoute()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getWeeklyCategoryMenuItem(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { params } = action.payload
    let url = `${baseUrl}/frontline/menu/`
    if (params?.weekly_category_id && params?.menu_category_id) {
      url += `?weekly_category_id=${params.weekly_category_id}&menu_category_id=${params.menu_category_id}`
    } else {
      url += `?food_name=${params?.menu_category_id}`
    }
    const { data } = yield call(axios.get, url)
    if (data.success) {
      const transformedData = data?.data?.items.map((item) => ({
        value: item.id,
        label: item.name
      }))
      yield put(slice.actions.setMenuList(transformedData))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* generateWeeklyQuestion(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/weekly/generate-question/`, action.payload)
    if (data.success) {
      yield put(calendarSlice.actions.setGeneratedQuestions(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addQuestionToChallenge(action) {
  try {
    const { payload, handleRoute } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.post,
      `${baseUrl}/weekly/weekly-challenge-question-map/`,
      payload
    )
    if (data.success) {
      if (data.code === 207) {
        toast.warning(data?.data?.message, {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "dark"
        })
      } else {
        handleRoute()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addToWeeklyQuestionBank(action) {
  try {
    const { payload, handleRoute } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/weekly/transfer-question/`, payload)
    if (data.success) {
      handleRoute()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteWeeklyQuestionFromBank(action) {
  try {
    const { questionId } = action.payload
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/weekly/questions/${questionId}/`)
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/weekly/question-bank-v2/?page=1&page_size=9999`
    )
    if (newData.success) {
      yield put(slice.actions.setWeeklyQuestionBank(newData.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* generateSoundbites(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/tts/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setSoundbites(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* generateSoundbiteText(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { onSuccess, payload } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/menu/generate-soundbite/`,
      payload
    )
    if (data?.success) {
      const content = data?.data?.soundbite_items[0][0]?.content
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess(content)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* aiEnhanceField(action) {
  // AI-enhances a single field. Per the API the response carries `enhanced_value`
  // at the top level (string for text fields, array for Array-type fields). No
  // global loader — the calling field shows its own per-button loading state.
  const { payload, onSuccess, onError } = action.payload || {}
  try {
    const { data } = yield call(axios.post, `${baseUrl}/frontline/menu-item/ai-enhance/`, payload)
    const enhancedValue = data?.enhanced_value ?? data?.data?.enhanced_value
    if (enhancedValue !== undefined && onSuccess && typeof onSuccess === "function") {
      onSuccess(enhancedValue)
    } else if (onError && typeof onError === "function") {
      onError()
    }
  } catch (e) {
    console.log(e)
    if (onError && typeof onError === "function") {
      onError()
    }
  }
}

export function* enhanceDidYouKnowField(action) {
  // AI-generates/refines a Did You Know or History heading/content field. The
  // current (possibly unsaved) text is passed in `payload.current_value`; the
  // response carries `enhanced_value` at the top level. No global loader — the
  // calling field shows its own per-button loading state.
  const { payload, onSuccess, onError } = action.payload || {}
  try {
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/menu-item/ai-enhance-did-you-know/`,
      payload
    )
    const enhancedValue = data?.enhanced_value ?? data?.data?.enhanced_value
    if (enhancedValue !== undefined && onSuccess && typeof onSuccess === "function") {
      onSuccess(enhancedValue)
    } else if (onError && typeof onError === "function") {
      onError()
    }
  } catch (e) {
    console.log(e)
    if (onError && typeof onError === "function") {
      onError()
    }
  }
}

export function* removeImageBackground(action) {
  // Removes the background from an already-uploaded image (by media id) and
  // returns the new transparent-PNG media ({ id, url }). No global loader — the
  // calling button shows its own loading state.
  const { payload, onSuccess, onError } = action.payload || {}
  try {
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/menu-item/remove-background/`,
      payload
    )
    const result = data?.data ?? data
    if (result?.url && onSuccess && typeof onSuccess === "function") {
      onSuccess(result)
    } else if (onError && typeof onError === "function") {
      onError()
    }
  } catch (e) {
    console.log(e)
    if (onError && typeof onError === "function") {
      onError()
    }
  }
}

export function* updateQuizQuestions(action) {
  try {
    const { quizId } = action.payload
    const { weeklyQuizId } = yield select((store) => store?.marketing)
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.post,
      `${baseUrl}/weekly/shuffle-questions/?quiz_id=${quizId}`
    )
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/weekly/weekly-quizzes/${weeklyQuizId}/questions/`
      )
      if (newData.success) {
        yield put(slice.actions.setViewQuizQuestions(newData.data?.questions ?? []))
        yield put(slice.actions.setQuizQuestionsCount(newData.data?.category_wise_count))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadBulkQuestion(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { csvUrl, onClose } = action.payload

    const headerParams = { headers: { "Content-Type": "multipart/form-data" } }
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/questions/bulk-upload/`,
      { file: csvUrl },
      headerParams
    )
    if (data.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/weekly/question-bank-v2/?page=1&platform=All&question_used=All`
      )
      if (newData.success) {
        yield put(slice.actions.setWeeklyQuestionBank(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* bulkDeleteQuestions(action) {
  try {
    const { payload, onClose } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.delete, `${baseUrl}/weekly/questions-v2/`, { data: payload })
    if (data.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/weekly/question-bank-v2/?page=1&platform=All&question_used=All`
      )
      if (newData.success) {
        yield put(slice.actions.setWeeklyQuestionBank(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getComments(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/weekly/questions-v2/${id}/comments`)
    if (data.success) {
      yield put(slice.actions.setCommentsData(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateCommentStatus(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, id } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/weekly/questions-v2/${id}/comments`,
      payload
    )
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/weekly/questions-v2/${id}/comments`
      )
      yield put(slice.actions.setCommentsData(newData?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* generateHistory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/menu/generate-history/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setHistoryData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* generateDidYouKnow(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/menu/generate-did-you-know/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setDidYouKnowData(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* setupWeeklyQuizzes(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { onSuccess, ...payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/weekly/setup-weekly-quizzes/`, payload)
    if (data?.success) {
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* setupWeeklyChallenges(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { onSuccess, ...payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/weekly/setup-weekly-challenges/`, payload)
    if (data?.success) {
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getSoundbiteVoiceIds() {
  try {
    const { data } = yield call(axios.get, `${baseUrl}/frontline/soundbite-voice-ids/`)
    if (data?.success) {
      yield put(slice.actions.setSoundbiteVoiceIds(data.data))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* swapWeeklyChallenges(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { onSuccess, payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/weekly/weekly-challenges/swap/`, payload)
    if (data?.success && typeof onSuccess === "function") {
      onSuccess()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadMenuForReview(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { file, file_type, onClose } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, file)
    if (data?.success) {
      const { data: newData } = yield call(axios.post, `${baseUrl}/frontline/onboarding/upload/`, {
        media_id: data?.data?.id,
        file_type
      })

      if (newData?.success) {
        yield put(slice.actions.setIsMenuUploading(true))
        yield put(appActions.setIsLoading(false))
        while (true) {
          const { data: progressData } = yield call(
            axios.get,
            `${baseUrl}/frontline/onboarding/upload/progress/${newData?.data?.job_id}`
          )
          if (progressData?.success) {
            onClose()
            yield put(slice.actions.setUploadProgress(progressData?.data))
            if (progressData?.data?.status !== "running") {
              yield put(slice.actions.setUploadJobId(null))
              yield put(slice.actions.setIsMenuUploading(false))
              yield put(slice.actions.setUploadProgress(null))
              break
            }
          }
          yield delay(3000)
        }
      }
    }
  } catch (e) {
    console.log(e)
    yield put(slice.actions.setUploadJobId(null))
    yield put(slice.actions.setUploadProgress(null))
    yield put(slice.actions.setIsMenuUploading(false))
  }
}

export function* getUploadStatus(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { callback } = action?.payload || {}
    const { data } = yield call(axios.get, `${baseUrl}/frontline/onboarding/upload/status/`)
    if (data.success) {
      yield put(slice.actions.setMenuUploadStatus(data.data.status))
      if (callback) {
        callback(data.data.status)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getReviewMenuCategories() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/menu/categories?pending_review=true`
    )
    if (data.success) {
      yield put(slice.actions.setReviewMenuCategories(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getReviewMenuPeriod() {
  const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/web-menu-list/?meal-period=${item}&food-type=${category}&pending_review=true`
    )
    if (data.success) {
      yield put(slice.actions.setReviewMenuPeriodData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getReviewBarMenuPeriod() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/bar-menu-web?pending_review=true`)
    if (data.success) {
      yield put(slice.actions.setReviewBarMenuPeriodData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getReviewWineMenuPeriod() {
  const { item } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
  try {
    yield put(appActions.setIsLoading(true))
    if (item === "wine by glass") {
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?wine-by-glass=True&pending_review=true`
      )
      if (data.success) {
        yield put(slice.actions.setReviewWineMenuPeriodData(data.data))
      }
    } else {
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/web-menu-list/?wine-by-bottle=True&pending_review=true`
      )
      if (data.success) {
        yield put(slice.actions.setReviewWineMenuPeriodData(data.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getReviewSpiritCMS() {
  try {
    const { menuCategory } = yield select((store) => store.dmv)
    if (menuCategory?.name) {
      yield put(appActions.setIsLoading(true))
      const { data } = yield call(
        axios.get,
        `${baseUrl}/frontline/spirit-web-menu/${menuCategory?.name}?platform=marketing&pending_review=true`
      )
      if (data.success) {
        yield put(slice.actions.setReviewSpiritData(data?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getReviewMenuSubCategory() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/food-type/?pending_review=true`)
    if (data.success) {
      yield put(slice.actions.setReviewMenuSubCategory(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* publishReviewMenu(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { onSuccess, payload } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/bulk-publish-menu-items/`,
      payload
    )
    if (data.success) {
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* exportMenuList() {
  try {
    yield put(appActions.setIsLoading(true))
    const { item, category } = yield select((store) => store?.marketing?.menu?.linkCategory || {})
    let url = ""

    if (item === "bar menu") {
      url = `${baseUrl}/frontline/bar-menu-web?export=true`
    } else if (item === "wine by glass") {
      url = `${baseUrl}/frontline/web-menu-list?wine-by-glass=true&export=true`
    } else if (item === "wine by bottle") {
      url = `${baseUrl}/frontline/web-menu-list?wine-by-bottle=true&export=true`
    } else if (item === "spirits") {
      url = `${baseUrl}/frontline/spirits-export/`
    } else {
      let params = ""
      if (item) {
        params = item.replace(/&/g, "%26")
      }
      url = `${baseUrl}/frontline/web-menu-list?export=true&meal-period=${params}&food-type=${category}`
    }

    const { data } = yield call(axios.get, url)
    if (data.success) {
      const { excel_download_url } = data.data

      if (excel_download_url) {
        const [metadata, base64Data] = excel_download_url.split(";base64,")
        const mimeType = metadata.split(":")[1].split(";")[0]
        const fileName = metadata.split("name=")[1] || `export.xlsx`
        const binaryData = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0))
        const blob = new Blob([binaryData], { type: mimeType })
        saveAs(blob, fileName)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}
